export default __webpack_public_path__ + "static/media/ministry_tourism-remove.f63951ee.png";